var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.insertVideoReviews)?_c('div',{staticClass:"reviews"},[_c('div',{ref:"sliderEl",staticClass:"reviews-slider",attrs:{"data-uno-dos-trends-uuid":_vm.insertVideoReviews}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }